import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useKakaoLoginQuery, getAgreementConfirmed } from '../react-queries/queries';

const KakaoLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [shouldLogin, setShouldLogin] = useState(false);
  const code = new URLSearchParams(location.search).get('code');
  const { data, isLoading, error } = useKakaoLoginQuery(code || '', { enabled: shouldLogin, staleTime: 120000 });

  useEffect(() => {
    if(!shouldLogin){
      setShouldLogin(true);
    }else{
      if(isLoading){
        return;
      }
      if (error) {
        alert('카카오 로그인에 실패했습니다.');
        navigate('/login');
      }else if (data) {
        getAgreementConfirmed().then(({ agreementConfirmed, privacyPolicyConfirmed }) => {
          //alert('agreementConfirmed: ' + agreementConfirmed);
          //alert('privacyPolicyConfirmed: ' + privacyPolicyConfirmed);
          if (!agreementConfirmed || !privacyPolicyConfirmed) {
            navigate('/signup/agreement', { state: {afterLogin: true} });
          } else {
            navigate('/home');
          }
        });
      }
    }
  }, [isLoading, error, data]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div>카카오 로그인 중...</div>
    </div>
  );
};

export default KakaoLoginPage; 